export default __webpack_public_path__ + "media/images/rank_04-9c8c4f0bddbf67c1e94e20b430b947a5.png";